import { Box, Button, Popover, Typography } from "@mui/material";
import ArrowDropDown from "@mui/icons-material/ArrowDropDown";
import Inbox from "@mui/icons-material/Inbox";
import { MouseEvent, useState } from "react";
import { Task } from "../../../api/Tasks";
import { TinyButton } from "../../../misc/TinyButton";
import { CalendarTask } from "./CalendarTask";

export function UnscheduledButton(props: {
    tasks: Task[];
    selectedId?: number;
    saving?: boolean;
    onSelect: (task: Task) => void;
    onContextMenu: (task: Task, e: MouseEvent) => void;
    onToggle: (task: Task, checked: boolean) => void;
    onDragStart: (task: Task) => void;
    onDragEnd: () => void;

    // onViewAll opens the whole list in the side panel
    onViewAll: () => void;
}) {
    const [anchor, setAnchor] = useState<HTMLElement | null>(null);

    return (
        <>
            <TinyButton
                disabled={props.tasks.length === 0}
                aria-haspopup="dialog"
                aria-expanded={!!anchor}
                startIcon={<Inbox sx={{ fontSize: 16 }} />}
                endIcon={<ArrowDropDown sx={{ fontSize: 18 }} />}
                onClick={e => setAnchor(e.currentTarget)}
            >
                Unscheduled ({props.tasks.length})
            </TinyButton>

            <Popover
                open={!!anchor}
                anchorEl={anchor}
                onClose={() => setAnchor(null)}
                anchorOrigin={{ vertical: "bottom", horizontal: "left" }}
            >
                <Box sx={{
                    display: "flex",
                    flexDirection: "column",
                    gap: 0.5,
                    width: 320,
                    maxHeight: 360,
                    overflow: "auto",
                    p: 1,
                }}>
                    <Box sx={{ display: "flex", alignItems: "center", justifyContent: "space-between" }}>
                        <Typography variant="caption" color="text.secondary">
                            Tasks with no due date
                        </Typography>
                        <Button size="small" onClick={() => {
                            setAnchor(null);
                            props.onViewAll();
                        }}>
                            View all
                        </Button>
                    </Box>

                    {props.tasks.map(task => (
                        <CalendarTask
                            key={task.id}
                            task={task}
                            selected={task.id === props.selectedId}
                            disabled={props.saving}
                            onClick={() => {
                                setAnchor(null);
                                props.onSelect(task);
                            }}
                            onContextMenu={e => props.onContextMenu(task, e)}
                            onToggle={checked => props.onToggle(task, checked)}
                            draggable
                            onDragStart={e => {
                                e.dataTransfer.effectAllowed = "move";
                                e.dataTransfer.setData("text/plain", String(task.id));

                                // the popover would otherwise swallow the drop
                                setAnchor(null);
                                props.onDragStart(task);
                            }}
                            onDragEnd={props.onDragEnd}
                        />
                    ))}
                </Box>
            </Popover>
        </>
    );
}
